// extracted by mini-css-extract-plugin
export default {"nav":"Admin_nav__oU2YP"};